export const isFeuilleDeMatchFull = (match) => {
    
    const {homeHolders, awayHolders, homeSubstitutes, awaySubstitutes} = match

    let myPlayersInMatch = homeHolders.length>0 && awayHolders.length>0 && [...homeHolders, ...awayHolders].every(p => p && p!=='')
    
    return myPlayersInMatch
}

export const isFeuilleDeMatchTeamFull = (match, teamId) => {
    
    const {homeHolders, awayHolders, homeSubstitutes, awaySubstitutes} = match

    return match.homeTeam._id === teamId ? homeHolders && homeHolders.length>0 && homeHolders.every(p => p && p!=='') : awayHolders && awayHolders.length>0 && awayHolders.every(p => p && p!=='')
}

export const isStepComplete = (holders, discipline) => {

    if(discipline === 'soccer')
        return holders.length === 11 && holders.every(v => v._id && v.numero!==undefined)

    if(discipline === 'rugby')
        return holders.length === 15 && holders.every(v => v._id && v.numero!==undefined)
    
    if(discipline === 'basket')
        return holders.length === 5 && holders.every(v => v._id && v.numero!==undefined)

    if(discipline === 'handball')
        return holders.length === 7 && holders.every(v => v._id && v.numero!==undefined)
}

export const getPlayerList = (match, teamId) => {
    if(isFeuilleDeMatchTeamFull(match, teamId)){
        let playersTeam1 = [...match.homeHolders].concat([...match.homeSubstitutes])
        let playersTeam2 = [...match.awayHolders].concat([...match.awaySubstitutes])

        let players = match.homeTeam._id === teamId ? playersTeam1 : playersTeam2
        return players.sort((a,b) => a.numero - b.numero)
    }else{
        let players = match.homeTeam._id === teamId ? match.homeTeam.players : match.awayTeam.players
        return players.sort((a,b) => a.number - b.number || a.lastname.localeCompare(b.lastname))
    }
}